import React from 'react';
import { FormattedMessage } from 'react-intl';
import { NWLineChart, SubTitle } from 'components';
import './LineChart.scss';

const LineChart = ({ title, data, listKeys }) => (
  <div className="nw-page-fundfactsheet__performanceVsPrice">
    <SubTitle title={(<FormattedMessage id={title} />)} />
    <div className="nw-page-fundfactsheet__lineChart">
      <NWLineChart
        data={data}
        listKey={listKeys}
      />
    </div>
  </div>
);

export default LineChart;
